import {removeDuplicates, sortByKey} from 'presentation/utils';
import {ExamUnits} from '../types';

export const formatExamUnit = (units: ExamUnits[], sortUnitsBy: keyof ExamUnits) => {
	const filterDuplicate = removeDuplicates(units);
	const sortedUnitsByName = filterDuplicate && sortByKey(filterDuplicate, sortUnitsBy);

	return sortedUnitsByName;
};
